function formatDateTime(dateString) {
  if (!dateString) return "-";
  try {
    const d = new Date(dateString);
    return d.toLocaleDateString("de-DE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return dateString;
  }
}

export default function AnalysisSummaryCard({ stats }) {
  const totalOpen =
    Number(stats.OPEN_CASES ?? 0) ||
    (stats.TYPES || []).reduce((sum, t) => sum + Number(t.OPEN || 0), 0);

  const lastWeek = stats.LAST_WEEK || {};
  const lastMonth = stats.LAST_MONTH || {};

  const fmtNum = (v) => (v === 0 ? "0" : v ? Number(v).toLocaleString() : "-");

  return (
    <div className="analysis-summary-card">
      <div className="analysis-summary-header">
        <div className="analysis-summary-title">Remediation Data</div>
        <div className="analysis-summary-status-label">Service Status</div>
      </div>

      <div className="analysis-summary-body">
        <div className="analysis-summary-details">
          <div>
            <strong>Last Update:</strong> {formatDateTime(stats.LAST_UPDATE)}
          </div>

          <div>
            <strong>Closed Cases:</strong>{" "}
            {Number(stats.CLOSED_CASES || 0).toLocaleString()}
          </div>

          <div>
            <strong>Open Cases:</strong> {totalOpen.toLocaleString()}
          </div>

          <div>
            <strong>Total Cases:</strong>{" "}
            {Number(stats.TOTAL_CASES || 0).toLocaleString()}
          </div>

          <div>
            <strong>Types:</strong> {(stats.TYPES || []).length}
          </div>
        </div>

        <div className="analysis-summary-periods">
          <div className="analysis-summary-period">
            <div className="analysis-summary-period-title">Last Week</div>
            <div>
              <strong>Closed Cases:</strong> {fmtNum(lastWeek.CLOSED_CASES)}
            </div>
            <div>
              <strong>New Cases:</strong> {fmtNum(lastWeek.NEW_CASES)}
            </div>
          </div>

          <div className="analysis-summary-period">
            <div className="analysis-summary-period-title">Last month</div>
            <div>
              <strong>Closed Cases:</strong> {fmtNum(lastMonth.CLOSED_CASES)}
            </div>
            <div>
              <strong>New Cases:</strong> {fmtNum(lastMonth.NEW_CASES)}
            </div>
          </div>
        </div>

        <div className="analysis-summary-status">
          <div className="analysis-trafficlight" aria-label="Service Status">
            <span
              className={`analysis-trafficlight-dot analysis-dot--red ${stats.AINSTEIN_STATUS !== "online" ? "is-on" : ""
                }`}
              title="Offline"
            />
            <span
              className="analysis-trafficlight-dot analysis-dot--yellow"
              title="Degraded"
            />
            <span
              className={`analysis-trafficlight-dot analysis-dot--green ${stats.AINSTEIN_STATUS === "online" ? "is-on" : ""
                }`}
              title="Online"
            />
          </div>
        </div>
      </div>
    </div>
  );
}